import { useQueryClient } from '@tanstack/react-query'
import {
  SubstitutionPreferencesQuery,
  SubstitutionsQuery,
  substitutionsQueryOptions,
  substitutionPreferenceQueryOptions,
} from '@/features/shop/services/Substitutions/queries'
import { useStoreParams } from '@/features/shared/utils/dataFetching/storeParams'

export const useInvalidatePreferenceQueries = () => {
  const queryClient = useQueryClient()
  const storeParams = useStoreParams()
  // this is added due to async issues with the out of stock service.
  // we need to inform the responsible BE team to fix this.
  return (productId: number) => {
    setTimeout(() => {
      queryClient.invalidateQueries({
        queryKey: [SubstitutionPreferencesQuery],
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: substitutionPreferenceQueryOptions({ productId, storeParams }).queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: [SubstitutionsQuery],
        exact: false,
      })
    }, 250)
  }
}

export const useFetchSubstitutionsQuery = () => {
  const queryClient = useQueryClient()
  const storeParams = useStoreParams()

  return ({ productId }: Pick<Parameters<typeof substitutionsQueryOptions>[0], 'productId'>) =>
    queryClient.query(
      substitutionsQueryOptions({
        storeParams,
        productId,
      }),
    )
}
